import { useEffect, useRef } from 'react'

export function useEffectTimeout (callback: () => void, delay: number, dependencies: any[]): void {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (delay < 0) {
      return // 0 is a valid delay
    }

    if (timeoutRef.current != null) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }

    timeoutRef.current = setTimeout(() => {
      callback()
    }, delay)

    return () => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [callback, delay, ...dependencies])
}
